import axios from "axios";

/**
 * Send credentials (cookies) with every request.
 * Attach admin token header if present in localStorage (dashboard users).
 * On 401/403 on dashboard pages, clear session and redirect to login.
 */
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  (config) => {
    // Admin dashboard token — stored in localStorage after admin login
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.token = token;
      if (!config.headers.api_key) config.headers.api_key = token;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

axios.interceptors.response.use(
  (response) => response,
  (err) => {
    const status = err.response?.status;
    const path = window.location.pathname;

    const isLoginPage = path === "/login";
    const isKioskPage = path === "/" || path === "/home" || path === "/pin";

    if (status === 401 || status === 403) {
      // Only clear admin session and redirect on dashboard pages.
      // Kiosk pages handle their own auth failures independently.
      if (!isLoginPage && !isKioskPage) {
        localStorage.removeItem("token");
        localStorage.removeItem("admin_session");
        localStorage.removeItem("location");
        localStorage.removeItem("role");
        localStorage.removeItem("user_id");
        window.location.href = "/login";
        return new Promise(() => {});
      }
    }

    return Promise.reject(err);
  }
);

export default axios;
